export default {
  frontRoutes: [
    {
      path: '/index/rec-course',
      name: 'IndexRecommendCourse',
      component: () => import(/* webpackChunkName: "course" */ '../views/course/Course.vue'),
    },
    {
      path: '/OpenCourse',
      name: 'OpenCourse',
      component: () => import(/* webpackChunkName: "course" */ '../views/course/Course.vue'),
    },
    {
      path: '/course',
      name: 'Course',
      component: () => import(/* webpackChunkName: "course" */ '../views/course/Course.vue'),
    },
    {
      path: '/course/classify',
      name: 'CourseListClassify',
      component: () => import(/* webpackChunkName: "course" */ '../views/course/Course.vue'),
    },
    {
      path: '/course/classify/:id',
      name: 'CourseListClassifyShow',
      component: () => import(/* webpackChunkName: "course" */ '../views/course/CourseShow.vue'),
    },
    {
      path: '/course/type',
      name: 'CourseListType',
      component: () => import(/* webpackChunkName: "course" */ '../views/course/Course.vue'),
    },
    {
      path: '/course/type/:id',
      name: 'CourseListTypeShow',
      component: () => import(/* webpackChunkName: "course" */ '../views/course/CourseShow.vue'),
    },
    {
      path: '/course/coupon',
      name: 'CourseCoupon',
      component: () => import(/* webpackChunkName: "course" */ '../views/course/CourseCoupon.vue'),
    },
    {
      path: '/course/:id',
      name: 'CourseShow',
      component: () => import(/* webpackChunkName: "course" */ '../views/course/CourseShow.vue'),
    },
    {
      path: '/packageCourseDetail/:id',
      name: 'PackageCourseDetail',
      component: () =>
        import(/* webpackChunkName: "course" */ '../views/course/PackageCourseDetail.vue'),
    },
    {
      path: '/video',
      name: 'Video',
      component: () => import(/* webpackChunkName: "course" */ '../views/course/Video.vue'),
      meta: {
        requireAuth: true,
      },
    },
  ],
  memberRoutes: [
    {
      path: '/member/study',
      name: 'MemberStudy',
      component: () =>
        import(
          /* webpackChunkName: "member" */
          '../views/member/studyCenter/MyCourse/index.vue'
        ),
      meta: {
        hideBreadcrumb: true,
        requireAuth: true,
        title: '我的课程',
        root: true,
      },
    },
    {
      path: '/member/study_task',
      name: 'MemberStudyTask',
      component: () =>
        import(
          /* webpackChunkName: "member" */
          '../views/member/studyCenter/StudyTask/index.vue'
        ),
      meta: {
        requireAuth: true,
        title: '我的任务',
        root: true,
      },
    },
    {
      path: '/member/calendar',
      name: 'MemberCalendar',
      component: () =>
        import(
          /* webpackChunkName: "member" */
          '../views/member/MemberCalendar.vue'
        ),
      meta: {
        requireAuth: true,
        title: '学习日历',
        root: true,
      },
    },
  ],
};
